import { TableContainer, ITableStructure } from '../../../base';
import { TableIds } from '../../../common';
import { useTableFilters } from './hooks/useTableFilters';
import { useTableCells } from './hooks/useTableCells';
import { useTableCallbacks } from './hooks/useTableCallbacks';

const TeamMembersTable = () => {
    const cells = useTableCells();
    const filters = useTableFilters();
    const { onMenuItemClick } = useTableCallbacks();

    const callbacks = {
        onMenuItemClick,
    };

    const tableStructure: ITableStructure = {
        id: TableIds.TEAM_MEMBERS,
        cells,
        filters,
    };

    return <TableContainer structure={tableStructure} callbacks={callbacks} />;
};

export default TeamMembersTable;
